// 社会招聘
import React from 'react'
import LxHeader from '@/components/LxHeader/Three'
// import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import { groupList } from '@/constants'
import defaultSetting from '@/setting'
import SocialCmp from './cmp/Social';
// const bannerImg = require('@/assets/images/social/banner02.jpg')
// const arrowIcon = require('@/assets/images/social/arrow.png')

class SocialRecruitment extends React.Component {
    constructor(props){
        super(props);
        this.state = {}
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    render() {
        return (
            <>
                <LxHeader></LxHeader>
                <main className={styles.social}>
                    <div className="banner lx-relative lx-fz0">
                        {/* <img className="lx-image-rendering lx-w100" src={bannerImg} alt="banner" /> */}
                        {/* <div className="lx-container">
                            <div className="banner-content">
                                <div className="banner-title lx-relative lx-fz44 lx-text-color-white">
                                    中国一汽<br/>2022年春季招聘
                                </div>
                                <div className="lx-fz24 lx-text-color-white">
                                    FAW<br/>campus recruitment<br/>in spring 2022
                                </div>
                                <Link to="#" className="banner-handle-btn lx-flex-row-center">
                                    <span className="lx-fz20 lx-text-color-white lx-mr5">立即加入</span>
                                    <img className="arrorIcon" src={arrowIcon} alt="icon" />
                                </Link>
                            </div>
                        </div> */}
                    </div>

                    <section className="section-fawGroup lx-pt10">
                        <div className="lx-container">
                            {/* <div className="lx-fz36 lx-fw600 lx-text-center lx-mb15">世界一流 时代先锋</div> */}
                            {/* <div className="section-sub-title lx-text-center lx-fz18 ">开放式工位，即时讨论，让灵感碰撞不受空间约束，不讲 title 和层级，敢于授权新人</div> */}
                            <SocialCmp list={groupList}></SocialCmp>
                        </div>
                    </section>
                </main>
            </>
        );
    }
  }
  
  export default SocialRecruitment;